__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "redefrota-cardan-web";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@chakra-ui/react", "2.8.2", () => (Promise.all([__webpack_require__.e(82), __webpack_require__.e(214), __webpack_require__.e(748), __webpack_require__.e(434), __webpack_require__.e(796), __webpack_require__.e(0)]).then(() => (() => (__webpack_require__(7082))))));
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(384), __webpack_require__.e(214), __webpack_require__.e(168)]).then(() => (() => (__webpack_require__(384))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(214), __webpack_require__.e(434), __webpack_require__.e(903)]).then(() => (() => (__webpack_require__(5903))))));
			register("framer-motion", "12.40.0", () => (Promise.all([__webpack_require__.e(51), __webpack_require__.e(214), __webpack_require__.e(292)]).then(() => (() => (__webpack_require__(6051))))));
			register("react-dom", "19.1.1", () => (Promise.all([__webpack_require__.e(214), __webpack_require__.e(950)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-router-dom", "7.0.2", () => (Promise.all([__webpack_require__.e(212), __webpack_require__.e(214), __webpack_require__.e(748), __webpack_require__.e(463), __webpack_require__.e(947)]).then(() => (() => (__webpack_require__(3367))))));
			register("react-router", "7.0.2", () => (Promise.all([__webpack_require__.e(212), __webpack_require__.e(214), __webpack_require__.e(325)]).then(() => (() => (__webpack_require__(4774))))));
			register("react", "19.1.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			initExternal(4762);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};